import React, { Component } from "react";
import { connect } from "react-redux";
import { Route, Redirect } from "react-router-dom";
import PropTypes from "prop-types";

import { isAuthenticated, getData } from "../../utils/util";
// import { hist } from "../../index";

class AuthGuardImp extends Component {
  componentWillReceiveProps = nextProps => {
    let adminData = getData("adminData");
    let roles = adminData ? adminData.assignRoles : [];
    let { location } = nextProps;
    let { pathname } = location;
    let path = pathname.slice(pathname.lastIndexOf("/") + 1);
    // if (
    //   (path === "manageusers" && roles.indexOf("Manage Users") === -1) ||
    //   (path === "imagesgallery" && roles.indexOf("Image Gallery") === -1) ||
    //   (path === "products" && roles.indexOf("Products") === -1) ||
    //   (path === "manageinappnotification" &&
    //     roles.indexOf("Push Notifications") === -1) ||
    //   (path === "imagevetting" && roles.indexOf("Images Vetting") === -1) ||
    //   ((path === "managefaq" ||
    //     path === "viewfaqcat" ||
    //     path === "addfaq" ||
    //     path === "viewfaq" ||
    //     path === "editfaq" ||
    //     path === "managecontent" ||
    //     path === "viewcontent" ||
    //     path === "editcontent") &&
    //     roles.indexOf("Manage Content") === -1) ||
    //   (path === "managereports" && roles.indexOf("Manage Reports") === -1)
    // ) {
    //   hist.push("/restrict");
    // }
  };

  render() {
    const { component: Template, ...rest } = this.props;

    return (
      <Route
        {...rest}
        render={props =>
          isAuthenticated() ? (
            <Template {...props} />
          ) : (
            <Redirect
              to={{
                pathname: "/admin/pages",
                state: { from: props.location }
              }}
            />
          )
        }
      />
    );
  }
}

AuthGuardImp.propTypes = {
  component: PropTypes.any.isRequired
  // loadAuthData: PropTypes.func.isRequired
};

export default connect(null)(AuthGuardImp);



// WEBPACK FOOTER //
// ./src/components/Common/AuthGuard.jsx